import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/consumer/dashboard/page';

export const Route = createFileRoute('/(consumer)/_authenticated/dashboard')({
  component: DashboardPage,
});
